// remove after mergingn https://github.com/plone/volto/pull/6870
import Body from '../../../../../../components/Blocks/Video/Body';
export default Body;
